import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

const markerIcon = L.divIcon({
  className: 'location-picker-map__marker',
  html: '<span></span>',
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

function MapUpdater({ position }) {
  const map = useMap();

  map.setView(position);
  return null;
}

function ClickHandler({ onPickLocation }) {
  useMapEvents({
    click(event) {
      onPickLocation({
        lat: String(event.latlng.lat),
        lon: String(event.latlng.lng),
      });
    },
  });

  return null;
}

function LocationPickerMap({ selectedLocation, onPickLocation }) {
  const position = [Number(selectedLocation?.lat || 27.7172), Number(selectedLocation?.lon || 85.324)];

  return (
    <MapContainer center={position} zoom={15} scrollWheelZoom className="checkout-location__map">
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapUpdater position={position} />
      <ClickHandler onPickLocation={onPickLocation} />
      <Marker position={position} icon={markerIcon} />
    </MapContainer>
  );
}

export default LocationPickerMap;
